import { render, staticRenderFns } from "./designBorder.vue?vue&type=template&id=2d3bd78e&"
import script from "./designBorder.vue?vue&type=script&lang=ts&"
export * from "./designBorder.vue?vue&type=script&lang=ts&"
import style0 from "./designBorder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports